import React, { useContext } from "react";
import { MenuItem, TextField } from "@mui/material";
import { StaffContext } from "../../../Context";
import Lang from "./Lang";

export default function TeacherChoice(props) {
  const {value,setValue,fullWidth} = props
  const { getStaffRole } = useContext(StaffContext)
  return (
    <div>
      <TextField
        select
        label={<Lang w="teacher" />}
        value={value}
        onChange={(val) => setValue(val.target.value)}
        fullWidth={fullWidth}
      >
        {getStaffRole("Teacher")
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
          .map((staffm) => (
            <MenuItem
              key={staffm._id}
              value={staffm._id}
            >
              {staffm.name}
            </MenuItem>
          ))}
      </TextField>
    </div>
  );
}
